import { render, staticRenderFns } from "./SubscriptionTable.vue?vue&type=template&id=2ba8269e&scoped=true&"
import script from "./SubscriptionTable.vue?vue&type=script&lang=js&"
export * from "./SubscriptionTable.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionTable.vue?vue&type=style&index=0&id=2ba8269e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8269e",
  null
  
)

export default component.exports